/**
 * @generated SignedSource<<b261eb9322adb9ddb07c1e3efdaeaf7d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSsoApiKeysBlocked_query$data = {
  readonly platform: {
    readonly ssoAPIKeys: boolean;
  };
  readonly whoami: {
    readonly user: {
      readonly ssoUser: boolean;
    };
  };
  readonly " $fragmentType": "useSsoApiKeysBlocked_query";
};
export type useSsoApiKeysBlocked_query$key = {
  readonly " $data"?: useSsoApiKeysBlocked_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSsoApiKeysBlocked_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSsoApiKeysBlocked_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Platform",
      "kind": "LinkedField",
      "name": "platform",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ssoAPIKeys",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ssoUser",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7924d819b26834fc23bc74b46bc44a30";

export default node;
